module.exports = __webpack_public_path__ + "static/media/emj21.bba19f61.svg";